module.exports = __webpack_public_path__ + "officialStatic/img/value-bg.e8dd940.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/value-bg.png
// module id = nGCx
// module chunks = 0